import { testimonials } from "../../../mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function Testimonials() {
  return (
    <section id="voice" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="用户口碑"
          title="老瓜友们怎么说"
          highlight="9看料"
          desc="从午休刷榜到深夜追更，来自不同圈层的网友评价，是这份热度追踪服务最真实的刻度。"
        />
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-secondary-900">
                  <i className={`${t.icon} w-4 h-4 flex items-center justify-center`}></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-5 rounded-3xl border border-background-200 bg-background-100/70 px-6 py-7 md:flex-row md:px-10">
          <div className="flex flex-col items-center gap-3 text-center md:flex-row md:gap-4 md:text-left">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-heart-3-fill w-5 h-5 flex items-center justify-center"></i>
            </span>
            <div>
              <p className="text-sm text-foreground-600">你觉得我们做得还不错？</p>
              <p className="mt-0.5 text-base font-semibold text-foreground-950">把 9看料 分享给同在一个瓜棚的瓜友吧</p>
            </div>
          </div>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-question-answer-fill w-4 h-4 flex items-center justify-center"></i>
            有问题来找我们
          </a>
        </div>
      </div>
    </section>
  );
}